export default __webpack_public_path__ + "static/media/socketiovideo.c9f07674.mp4";